if (!customElements.get('narvar-tracking')) {
  class NarvarTracking extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.addEventListener('submit', (e) => {
        if (!e.target.closest('[data-tracking-form]')) return;
        e.preventDefault();
        
      this.querySelector('[data-order-details]').classList.add(`hidden`);
      this.email = this.querySelector('[data-email]')?.value;
      this.orderNum = this.querySelector('[data-tracking-number]')?.value;
        this.checkOrder();
      });
    }
    
    async checkOrder() {
      document.body.classList.add('loading');
      await fetch(`${window.shop.config.api_url}/orders/name?order_name=${this.orderNum}`, {
        method: 'GET',
      })
        .then(res => res.json())
        .then(arr => {
          // if (!arr) return;
          let trackingNumbers, trackingCompanies = [];
          if (arr.length > 0 && arr[0].shipped) {
            trackingNumbers = arr.map((obj) => obj.tracking_numbers.map(x => x)).join('');
            trackingCompanies = arr.map((obj) => obj.tracking_company);
          }
                    
          window.narvar('track', {
            retailer: 'venus',
            locale_language: 'en', // Put locale language code here
            locale_country: 'US', // Put locale country code here
            tracking_numbers: trackingNumbers, // Put tracking number here
            carrier: trackingCompanies, // Put carrier moniker here
            order_number: this.orderNum, // Put order number here
            email: this.email,
          });
        })
        .catch(err => {
          this.querySelector('[data-order-details]').classList.remove(`hidden`);
        })
        .finally(() => document.body.classList.remove('loading'));
    }
  }

  customElements.define('narvar-tracking', NarvarTracking);
}
